export enum CreateBatchScreenFields {
    RACK = 1, 
    PLATE = 2, 
    TUBE2DBARCODE = 3,
    DNACONCENTRATION = 4
};